<template>
  <div class="list-box">
    <el-row>
      可分配金额剩余
      <span style="color: seagreen">{{ availableAmount }}</span> 元
    </el-row>
    <el-row>
      <el-col :span="20" :offset="1">
        <vxe-toolbar>
          <template v-slot:buttons>
            <vxe-button @click="addTable()">添加人员</vxe-button>
          </template>
        </vxe-toolbar>
        <vxe-table :align="allAlign" :data="tableData">
          <vxe-table-column
            field="userCode"
            title="人员编码"
          ></vxe-table-column>
          <vxe-table-column
            field="userName"
            title="人员名称"
          ></vxe-table-column>
          <vxe-table-column field="amount500Above" title="500(含)以上(元)">
            <template v-slot="{ row }">
              <el-input
                v-model="row.amount500Above"
                type="number"
                placeholder="请输入500(含)以上(元)"
                precision="2"
                min="0"
                @change="reSetMoney"
              />
            </template>
          </vxe-table-column>
          <vxe-table-column field="amountOtherProduct" title="其他产品(元)">
            <template v-slot="{ row }">
              <el-input
                v-model="row.amountOtherProduct"
                type="number"
                placeholder="请输入其他产品(元)"
                precision="2"
                min="0"
                @change="reSetMoney"
              />
            </template>
          </vxe-table-column>
          <vxe-table-column field="amountCustomProduct" title="定制产品(元)">
            <template v-slot="{ row }">
              <el-input
                v-model="row.amountCustomProduct"
                type="number"
                placeholder="请输入定制产品(元)"
                precision="2"
                min="0"
                @change="reSetMoney"
              />
            </template>
          </vxe-table-column>
          <vxe-table-column field="totalAmount" title="合计(元)">
            <template v-slot="{ row }">
              <span>{{ row.totalAmount }}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column label="操作" align="center">
            <template #default="{ row }">
              <el-button size="mini" type="danger" @click="handleDelete(row)"
                >删除</el-button
              >
            </template>
          </vxe-table-column>
        </vxe-table>
      </el-col>
    </el-row>

    <SelectConfig ref="selectConfig" @onGetSelect="onGetSelect" />
  </div>
</template>

<script>
import SelectConfig from '@/found/components/select_org_cus_ter/select_config.vue';

export default {
  name: 'PeopleList',
  components: {
    SelectConfig,
  },
  props: {
    value: Array,
    mainTotal: Number,
  },
  watch: {
    value() {
      this.tableData = this.value;
    },
    mainTotal: {
      handler(newVal) {
        if (newVal) {
          this.getAvailableAmount(newVal);
        }
      },
      immediate: true,
      deep: true,
    },
  },
  data() {
    return {
      modalConfig: {}, // 弹框信息
      formConfig: {
        tableUrl: '',
      }, // 弹框数据
      allAlign: null,
      modalType: '', // 弹框包含非包含
      availableAmount: 0,
      tableData: [],
    };
  },
  created() {},
  methods: {
    addTable() {
      const selectionList = [];
      const list = this.tableData;
      list.forEach((v) => {
        selectionList.push(v.userName);
      });
      const params = {
        functionCode: 'choose-people-list',
        parentCode: 'CRM20260605000000003',
        data: list,
        selectionList,
        idKey: 'userName',
      };
      this.$refs.selectConfig.openSelectModal(params);
    },
    onGetSelect(val) {
      if (val && val.length > 0) {
        const newRows = val.map((v) => ({
          userCode: v.userName,
          userName: v.fullName || v.userName,
          amount500Above: 0,
          amountOtherProduct: 0,
          amountCustomProduct: 0,
          totalAmount: 0,
        }));

        this.tableData = [...this.tableData, ...newRows].filter(
          (item, index, arr) => arr.findIndex(
            (t) => t.userCode === item.userCode
                || t.userName === item.userName
                || t.userCode === item.userName
                || t.userName === item.userCode,
          ) === index,
        );
        this.reSetMoney();
      }
    },
    handleDelete(obj) {
      this.tableData = this.tableData.filter(
        (v) => v.userCode !== obj.userCode,
      );
      this.reSetMoney();
    },
    reSetMoney() {
      this.tableData = this.tableData.map((v) => ({
        ...v,
        totalAmount:
          (v.amount500Above * 100
            + v.amountOtherProduct * 100
            + v.amountCustomProduct * 100)
          / 100,
      }));
      this.$emit('input', this.tableData);
    },
    getAvailableAmount(val) {
      const total = val;
      // this.tableData.forEach((v) => {
      //   total = (total * 100 - v.totalAmount * 100) / 100;
      // });
      this.availableAmount = total;
    },
    // 打开弹窗
    openModal() {
      this.modalConfig = {
        ...this.modalConfig,
        ...{ visible: true, type: 'Modal' },
      };
    },
    // 关闭弹窗
    closeModal() {
      this.modalConfig = { ...this.modalConfig, visible: false };
    },
  },
};
</script>

<style lang="less" scoped>
</style>
